import { UserResponse } from './type';
import { config } from '@/config';

const regionedApiHosts = ['eu', 'au'];

const modifyAppHostUrl = (currAppHost: string, region: string) => {
  const newAppHostArr = currAppHost.split('.');
  newAppHostArr.splice(1, 0, region);
  return newAppHostArr.join('.');
};

export const getCookie = (cname: string) => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

const isEuRegion = () => {
  return getCookie('client_region') === 'eu-central-1';
};

const isAuRegion = () => {
  return getCookie('client_region') === 'ap-southeast-2';
};

const isRegionedApiHost = () => {
  const currHref = window.location.href;
  const apiDocsHost = currHref.split('/')[2].split('.');
  const region = apiDocsHost[1];
  return regionedApiHosts.includes(region);
};

const getCbAppHost = () => {
  return `${config.cbProtocol}://app.${config.cbDomain}`;
};

export const regionedAppHostUrl = (isLogin: boolean) => {
  const currentHref = encodeURIComponent(window.location.href.split('#')[0]);
  const loginRef = isLogin ? '/login?forward=' : '/logout?forward=';
  let url = '';
  let newAppHost = getCbAppHost();
  if (isEuRegion()) {
    if (!isRegionedApiHost()) {
      newAppHost = modifyAppHostUrl(getCbAppHost(), 'eu');
    }
    url = `${newAppHost}${loginRef}${currentHref}&ref=bhdocs`;
  } else if (isAuRegion()) {
    if (!isRegionedApiHost()) {
      newAppHost = modifyAppHostUrl(getCbAppHost(), 'au');
    }
    url = `${newAppHost}${loginRef}${currentHref}&ref=bhdocs`;
  } else {
    url = `${newAppHost}${loginRef}${currentHref}&ref=bhdocs`;
  }

  return url;
};

export const onFetchCurrentVersion = (
  user?: UserResponse | null,
  index?: number
) => {
  let pcv = '1.0';
  if (index !== undefined) {
    if (
      user != null &&
      user.site_configurations != null &&
      user.site_configurations[index] != null
    ) {
      pcv = user.site_configurations[index].is_item_model ? '2.0' : '1.0';
    }
  }
  return pcv;
};
